import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from 'swiper/modules';
import { useTranslation, Trans } from 'react-i18next';

import "swiper/css";
import "swiper/css/pagination";

import place1 from "../../../assets/assets-safari/places/1.webp";
import place2 from "../../../assets/assets-safari/places/2.webp";
import place3 from "../../../assets/assets-safari/places/3.webp";
import place4 from "../../../assets/assets-safari/places/4.webp";
import place5 from "../../../assets/assets-safari/places/5.webp";
import place6 from "../../../assets/assets-safari/places/6.webp";
import place7 from "../../../assets/assets-safari/places/7.webp";
import place8 from "../../../assets/assets-safari/places/8.webp";
import place9 from "../../../assets/assets-safari/places/9.webp";

import './SafariLodgesSlider.scss';
import SpeakToExpertButton from "src/components/home/SpeakToExpertButton";

const lodges = [
  { img: place5, label: "Mara Nyika Camp by Great Plains Conservation" },
  { img: place8, label: "Waterside at Royal Malewane" },
  { img: place7, label: "Wilderness Bisate" },
  { img: place9, label: "Four Seasons Safari Lodge Serengeti" },
  { img: place1, label: "Ngorongoro Lodge member of Meliá Collection" },
  { img: place4, label: "andBeyond Klein's Camp" },
  { img: place2, label: "Singita Ebony" },
  { img: place3, label: "Tembo Plains Camp, Relais & Chateaux" },
  { img: place6, label: "Singita Serengeti House" },
];

const SafariLodgesSlider = () => {
  const { t } = useTranslation('safari');
  const { t: tCommon } = useTranslation('common');
  return (
    <div className="safari_lodges lg:!py-[60px] sm:!py-10 !py-8">
      <h2 className="section-heading text-center mb-6 sm:mb-8 lg:mb-11 px-5 sm:px-6">
        <Trans
          i18nKey="lodges.heading"
          ns="safari"
          components={{ br1: <br className="sm:hidden" /> }}
        />
      </h2>

      <div className="min-h-[50vw] sm:min-h-[312px] lg:min-h-[462px]">
        <Swiper
          modules={[Pagination]}
          loop={true}
          slidesPerView={"auto"}
          centeredSlides={true}
          slideToClickedSlide={true}
          spaceBetween={13}
          pagination={{ clickable: true, el: ".safari_lodges_pagination" }}
          speed={300}
          touchEventsTarget="container"
          breakpoints={{
            640: { spaceBetween: 26 },
            1100: { spaceBetween: 40 }
          }}
          className="safari_lodges_slider"
        >
          {lodges.map((lodge, index) => (
            <SwiperSlide key={index}>
              <div className="safari_lodges_item">
                <div className="safari_lodges_item__img">
                  <img src={lodge.img} alt={lodge.label} />
                </div>
                <div className="safari_lodges_item__label">
                  <span>{lodge.label}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <p className="safari_lodges_bottom_text mx-auto sm:max-w-full">
        {t('lodges.footerNote')}
      </p>
      <div className="pagination safari_lodges_pagination"></div>
      <div className="flex justify-center">
        <SpeakToExpertButton text={tCommon('cta.planSafariAdventure')} />
      </div>
    </div>
  );
};

export default SafariLodgesSlider;
